import styled from "styled-components";
import { TextInputField } from "../../../utils/commonStyledComponents/commonStyled";

export const InheritTextInputField = styled(TextInputField)`
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px;
`;

export const InputWithRightButtonWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 380px;
  display: inline-block;
`;

export const InputRightButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 11px;
  color: #ff8038;
  padding: 4px 6px;
  font-weight: 500;
  white-space: nowrap;

  &:hover:not(:disabled) {
    text-decoration: underline;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
`;
